import React from 'react';
import './TopHighlight.css';

const updates = [
  {
    title: "Prerna Srot Samman",
    date: "2025-08-23"
  },
//   {
//     title: "Art Exhibition Video Added",
//     date: "2025-08-18"
//   }
];

function TopHighlight() {
  const currentDate = new Date();
  const latestUpdate = updates.find(update => {
    const diffDays = (currentDate - new Date(update.date)) / (1000 * 60 * 60 * 24);
    return diffDays <= 7; // Show if within 7 days
  });

  if (!latestUpdate) return null;

  return (
    <div className="top-highlight">
      <p>🔥 New Update: <strong>{latestUpdate.title}</strong></p>
     <a
  href="#"
  className="view-btn"
  onClick={(e) => {
    e.preventDefault();
    const section = document.querySelector('.updates-section'); // target by class
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  }}
>
  View Now
</a>

    </div>
  );
}

export default TopHighlight;
